import type React from 'react';

export interface PageHeaderTitleProps {
  children: React.ReactNode;
}

const PageHeaderTitle = ({ children }: PageHeaderTitleProps) => {
  return <div className='flex flex-col items-start'>{children}</div>;
};

export default PageHeaderTitle;
